import React, { useState, useEffect } from "react";

const Diaporama = ({ images, interval }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, interval);

    return () => clearInterval(timer);
  }, [images.length, interval]);

  return (
    <div className="home-diaporama">
      {images.map((slide, index) => (
        <img
          key={index}
          src={slide.media_url}
          alt={slide.media_title}
          className={`home-diaporama-image ${
            index === currentIndex ? "fade-in" : "fade-out"
          }`}
        />
      ))}
    </div>
  );
};

export default Diaporama;

/*import React, { useState, useEffect } from "react";

const Diaporama = ({ images, interval }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, interval);

    return () => clearInterval(timer);
  }, [images.length, interval]);

  return (
    <div className="home-diaporama">
      {images.map((slide, index) => (
        <img
          key={index}
          src={slide.url}
          alt={slide.alt}
          className={`home-diaporama-image ${
            index === currentIndex ? "fade-in" : "fade-out"
          }`}
        />
      ))}
    </div>
  );
};

export default Diaporama;
*/
